/**
 * Possible values are:
  - INCOMPLETE_DATA
      Indicates a customer who has incomplete identification data that should be completed
      Possible missing data:
        birthCode
        birthDate
        idId
        idType
        idIssuedCountry
        companyRegNo
        companyTaxNo
  - INCOMPLETE_DATA_MERGE_IN_PROGRESS
      Indicates a customer whose merge is currently being processed
  - INCOMPLETE_DATA_MERGE_DONE
      Indicates a customer whose merge has finished.

 */
export type CustomerExtendedTypeEnum = (typeof CustomerExtendedTypeEnum)[keyof typeof CustomerExtendedTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerExtendedTypeEnum = {
  INCOMPLETE_DATA: 'INCOMPLETE_DATA',
  INCOMPLETE_DATA_MERGE_IN_PROGRESS: 'INCOMPLETE_DATA_MERGE_IN_PROGRESS',
  INCOMPLETE_DATA_MERGE_DONE: 'INCOMPLETE_DATA_MERGE_DONE',
} as const;
